const state = {
  invoice: [],
  loadingInvoice: false,
};

const getters = {
  invoice(state) {
    return state.invoice;
  },
  loadingInvoice(state) {
    return state.loadingInvoice;
  },
};

const mutations = {
  UPDATE_INVOICE(state, invoice) {
    state.invoice = invoice;
  },
  UPDATE_LOADING_INVOICE(state, loadingInvoice) {
    state.loadingInvoice = loadingInvoice;
  },
};

const actions = {
  updateInvoice({ commit }, invoice) {
    commit("UPDATE_INVOICE", invoice);
  },
  updateLoadingInvoice({ commit }, loadingInvoice) {
    commit("UPDATE_LOADING_INVOICE", loadingInvoice);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
